module.exports = __webpack_public_path__ + "static/media/points-earned.25cd201e.svg";